import moment from 'jalali-moment'
import baseConfig from '@/../baseConfig'

export function removeCharFromString(fullString, removeChar) {
  fullString = fullString + ''
  return fullString.replaceAll(removeChar, '')
}

export function getImage(imageUrl) {
  const result = imageUrl.includes('http')
  if (result) {
    return imageUrl
  }

  return baseConfig.basUrlRaw + imageUrl
}

export function formConfig(widgets) {
  widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
    e.loading = false
    if (e.type !== 'dropdown') {
      if (typeof e.validations !== 'undefined') {
        e.validations.map(v => (v.validation === 'isRequired' ? e.rules.push(x => !!x || v.message) : v.validation === 'isHigherLength' ? e.rules.push(x => x.length >= v.value || v.message) : v.validation === 'isLowerLength' ? e.rules.push(x => x.length <= v.value || v.message) : v.validation === 'isEmail' ? e.rules.push(x => /.+@.+/.test(x) || v.message) : v.validation === 'isGtNumber' ? e.rules.push(x => parseInt(removeCharFromString(x,',')) >= parseInt(removeCharFromString(v.value,',')) || v.message) : v.validation === 'isLtNumber' ? e.rules.push(x => x <= v.value || v.message) : v.validation === 'isNumber' ? e.rules.push(x => /^\d+$/.test(x) || v.message) : v.validation === 'isCellPhone' ? e.rules.push(x => /(0|\+98)?([ ]|-|[()]){0,2}9[1|2|3|4]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/ig.test(x) || v.message) : v.validation === 'isString' ? e.rules.push(x => /^/.test(x) || v.message) : null))
      }
    } else if (typeof e.validations !== 'undefined') {
      //  e.validations.map(v => v.validation === 'isRequired' ? console.log(v.lenght) : null)
    }
  }) : null))
  widgets.map(w => (w.type === 'form' ? w.data.updateId = 0 : null))
  widgets.map(w => (w.type === 'form' ? w.data.valid = true : null))
  widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
    if (typeof e.validations !== 'undefined') {
      e.validations.map(v => (v.validation === 'isRequired' ? w.data.valid = false : v.validation === 'isHigherLength' ? w.data.valid = false : v.validation === 'isLowerLength' ? w.data.valid = false : v.validation === 'isEmail' ? w.data.valid = false : v.validation === 'isGtNumber' ? w.data.valid = false : v.validation === 'isLtNumber' ? w.data.valid = false : v.validation === 'isNumber' ? w.data.valid = false : v.validation === 'isCellPhone' ? w.data.valid = false : v.validation === 'isString' ? w.data.valid = false : null))
    }
  }) : null))
  widgets.map(w => (w.type === 'form' ? w.data.elements.map(e => {
    if (e.type === 'date') {
      // eslint-disable-next-line no-use-before-define
      let doConvert = false
      let convertType = '/'
      console.log(e.model)
      if (e.model !== '') {
        if (e.model!== null){
          let checkJalali = e.model.split('/')
          if (checkJalali[0] === '') {
            checkJalali = e.model.split('-')
          }
          if (checkJalali[0] !== '') {
            convertType = '-'
          }
          console.log(checkJalali[0])
          if (parseInt(checkJalali[0], 10) > 2010) {
            doConvert = true
          }
          if (doConvert) {
            if (convertType === '/') {
              // eslint-disable-next-line no-use-before-define
              e.model = convertDateToPersian2(e.model)
              console.log('/')
            }
            if (convertType === '-') {
              console.log('-')
              // eslint-disable-next-line no-use-before-define
              e.model = convertDateToPersian(e.model)
            }
          }
        }
      }
    }
    if (e.type === 'number' && e.decimal === 0) {
      e.model = parseInt(e.model, 10)
    }
  }) : null))

  return widgets
}

export function tableDateHandler(widgets) {

  widgets.map(w => (w.type === 'table' ? w.data.columns.map(c => (c.type === 'date' ? w.data.rows.map(r => (typeof (r[c.name]) !== 'undefined' ? r[c.name] !== null ? r[c.name] !== '' ? r[c.name] = convertDateToPersian(r[c.name]) : null : null : null)) : null)) : null))
  widgets.map(w => (w.type === 'table' ? w.data.columns.map(c => (c.type === 'dateTime' ? w.data.rows.map(r => (typeof (r[c.name]) !== 'undefined' ? r[c.name] !== null ? r[c.name] !== '' ? r[c.name] = convertDateTimeToPersian(r[c.name]) : null : null : null)) : null)) : null))
  widgets.map(w => (w.type === 'table' ? w.data.columns.map(c => (c.type === 'text' && c.numberFormat === true ? c.decimal === 0 ? w.data.rows.map(r => (typeof (r[c.name]) !== 'undefined' ? r[c.name] !== null ? r[c.name] !== '' ? r[c.name] = Intl.NumberFormat().format(parseInt(r[c.name], 10)) : null : null : null)) : w.data.rows.map(r => (typeof (r[c.name]) !== 'undefined' ? r[c.name] !== null ? r[c.name] !== '' ? r[c.name] = parseFloat(r[c.name]).toFixed(c.decimal) : null : null : null)) : null)) : null))

  return widgets
}

export function convertDateToPersian(date) {
  return moment.from(date, 'en', 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
}

export function convertDateToPersian2(date) {
  return moment.from(date, 'en', 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')
}

export function convertDateTimeToPersian(date) {
  return moment.from(date, 'en', 'YYYY-MM-DD h:m:s').locale('fa').format('YYYY/MM/DD  H:mm:ss')
}

export function tablePaginationHandler(contentWidgets, leftSidebarWidgets, rightSidebarWidgets, headerSidebarWidgets, footerSidebarWidgets) {
  const pagination = []
  contentWidgets.map(w => (w.type === 'table' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))
  contentWidgets.map(w => (w.type === 'productList' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))

  contentWidgets.map(w=>{
    if (w.type==='tabGroup'){
      w.data.tab.map(t=>{
        t.widget.map(cw=>{
         cw.data.tab.map(tt=>{
           tt.widget.map(fw=>{
             if (fw.type === 'productList' && fw.data.serverPagination === 1){
               pagination.push({table: fw.data.name,
                page: fw.data.pagination.current_page,})
             }
           })
         })
        })
      })
    }
  })

  leftSidebarWidgets.map(w => (w.type === 'table' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))
  leftSidebarWidgets.map(w => (w.type === 'productList' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))

  rightSidebarWidgets.map(w => (w.type === 'table' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))
  rightSidebarWidgets.map(w => (w.type === 'productList' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))

  headerSidebarWidgets.map(w => (w.type === 'table' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))
  headerSidebarWidgets.map(w => (w.type === 'productList' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))

  footerSidebarWidgets.map(w => (w.type === 'table' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))

  footerSidebarWidgets.map(w => (w.type === 'productList' && w.data.serverPagination === 1 ? pagination.push({
    table: w.data.name,
    page: w.data.pagination.current_page,
  }) : null))

  return pagination
}

export function initialSidebarsSize(page) {
  const mainContentSize = {
    size: 12,
    sizeSm: 12,
    sizeMd: 12,
    sizeLg: 12,
    sizeXl: 12,
  }

  if (page.rightSidebar.widget.length > 0) {
    mainContentSize.size = 12
  }
  if (page.leftSidebar.widget.length > 0) {
    mainContentSize.size = 12
  }

  if (page.rightSidebar.widget.length > 0) {
    mainContentSize.sizeSm = 12
  }
  if (page.leftSidebar.widget.length > 0) {
    mainContentSize.sizeSm = 12
  }
  if (page.rightSidebar.widget.length > 0) {
    mainContentSize.sizeMd = 12
  }
  if (page.leftSidebar.widget.length > 0) {
    mainContentSize.sizeMd = 12
  }
  if (page.rightSidebar.widget.length > 0) {
    mainContentSize.sizeLg -= 3
  }
  if (page.leftSidebar.widget.length > 0) {
    mainContentSize.sizeLg -= 3
  }
  if (page.rightSidebar.widget.length > 0) {
    mainContentSize.sizeXl -= 2
  }
  if (page.leftSidebar.widget.length > 0) {
    mainContentSize.sizeXl -= 2
  }

  return mainContentSize
}

function getFirstRow(widget, editOrShowTarget) {
  let record = null
  widget.map(w => (w.type === 'table' ? w.data.name === editOrShowTarget.split('/')[0] ? record = w.data.rows[0] : null : null))

  return record
}

function initForm(widget, editOrShowTarget, record, paramId) {
  let imageFormUrl = ''
  widget.map(w => (w.type === 'form' && w.data.id === editOrShowTarget.split('/')[0] ? w.data.elements.map(e => (e.type === 'text' || e.type === 'dropdown' || e.type === 'textarea' || e.type === 'radiobutton' || e.type === 'date' || e.type === 'time' ? record[e.name] !== null ? e.model = record[e.name].toString() : null : e.type === 'checkbox' ? record[e.name] !== null ? e.model = record[e.name].replace('[', '').replace(']', '').split(',') : null : e.type === 'image' ? record[e.name] !== null ? imageFormUrl = record[e.name] : null : null)) : null))
  widget.map(w => (w.type === 'form' && w.data.id === editOrShowTarget.split('/')[0] ? w.data.updateId = paramId : null))
  widget.map(w => (w.type === 'form' && w.data.id === editOrShowTarget.split('/')[0] ? w.data.valid = false : null))

  return {
    imageFormUrl,
    widget,
  }
}

export function initGroups(widget) {
  widget.map(w => (w.type === 'group' ? w.data.widget = [] : null))

  widget.map(w => (w.type === 'group' ? widget.map(wfc => {
    if (w.data.name === wfc.group) {
      w.data.widget.push(wfc)
    }
  }) : null))

  widget = widget.filter(w => w.group === '')

  return widget
}
export function initPagination(widget){

  return widget
}

export function editOrShowHandler(paramId, editOrShowTarget, page) {
  let record = null
  let imageFormUrl = ''
  const firstRowContent = getFirstRow(page.content.widget, editOrShowTarget)
  const firstRowLeftSidebar = getFirstRow(page.content.widget, editOrShowTarget)
  const firstRowRightSidebar = getFirstRow(page.content.widget, editOrShowTarget)
  const firstRowHeaderSidebar = getFirstRow(page.content.widget, editOrShowTarget)
  const firstRowFooterSidebar = getFirstRow(page.content.widget, editOrShowTarget)
  if (firstRowContent !== null) {
    record = firstRowContent
  } else if (firstRowLeftSidebar !== null) {
    record = firstRowLeftSidebar
  } else if (firstRowRightSidebar !== null) {
    record = firstRowRightSidebar
  } else if (firstRowHeaderSidebar !== null) {
    record = firstRowHeaderSidebar
  } else if (firstRowFooterSidebar !== null) {
    record = firstRowFooterSidebar
  }

  if (record !== null) {
    const initFormContent = initForm(page.content.widget, editOrShowTarget, record, paramId)
    const initFormLeftSidebar = initForm(page.leftSidebar.widget, editOrShowTarget, record, paramId)
    const initFormRightSidebar = initForm(page.rightSidebar.widget, editOrShowTarget, record, paramId)
    const initFormHeaderSidebar = initForm(page.headerSidebar.widget, editOrShowTarget, record, paramId)
    const initFormFooterSidebar = initForm(page.footerSidebar.widget, editOrShowTarget, record, paramId)
    page.content.widget = initFormContent.widget
    page.leftSidebar.widget = initFormLeftSidebar.widget
    page.rightSidebar.widget = initFormRightSidebar.widget
    page.headerSidebar.widget = initFormHeaderSidebar.widget
    page.footerSidebar.widget = initFormFooterSidebar.widget
    if (initFormContent.imageFormUrl !== '') imageFormUrl = initFormContent.imageFormUrl
    if (initFormLeftSidebar.imageFormUrl !== '') imageFormUrl = initFormLeftSidebar.imageFormUrl
    if (initFormRightSidebar.imageFormUrl !== '') imageFormUrl = initFormRightSidebar.imageFormUrl
    if (initFormHeaderSidebar.imageFormUrl !== '') imageFormUrl = initFormHeaderSidebar.imageFormUrl
    if (initFormFooterSidebar.imageFormUrl !== '') imageFormUrl = initFormFooterSidebar.imageFormUrl
  }

  return {
    record,
    imageFormUrl,
    page,
  }
}


export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
